<template>
    <div class="about-us">
      <div class="header-bottom container">
        <div class="line-style">
          <span class="dot"></span>
          <span class="lines"></span>
        </div>
        <div class="font-size">
          <div class="text">定制服务</div>
          <div class="letter">Tailored Logistics Solutions</div>
        </div>
        <div class="line-style">
          <span class="lines"></span>
          <span class="dot"></span>
        </div>
      </div>
      <div class="container">
          <div class="introduce-main">
            <div class="main-title">如果您有定制物流服务的需求，可以留下您的联系方式和您的需求。</div>
            <div class="main-sub">If you require customized logistics services, </div>
            <div class="main-sub" style="margin-bottom: 20px;">please leave your contact information and specific requirements.</div>
            <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="80px">
                <el-form-item label="联系人姓名" prop="name" required align="left">
                    <el-input v-model="form.name" placeholder="请输入联系人姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone" required align="left">
                    <el-input v-model="form.phone" type="number" placeholder="请输入联系电话号码"></el-input>
                </el-form-item>
                <el-form-item label="线路起终点" align="left">
                    <el-input v-model="form.address" placeholder="请输入线路起终点"></el-input>
                </el-form-item>
                <el-form-item label="备注说明" align="left">
                    <el-input v-model="form.remark" placeholder="如果您有更多的定制需求，请备注您的需求"></el-input>
                </el-form-item>
                <el-button type="primary" class="submit-btn" @click="onSubmit">提交需求</el-button>
            </el-form>
          </div>
      </div>
      <div class="scope-of-services">
        <div class="container">
            <div class="server-title"><span class="text-title">{{contentText.aboutUs.scopeOfServices.textTitle}}</span><span class="latter-title">{{contentText.aboutUs.scopeOfServices.latterTitle}}</span></div>
            <div class="server-contetn">
              {{contentText.aboutUs.scopeOfServices.content}}
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {contactUs} from '@/api/index.js';
  export default {
    data() {
      return {
        form:{
            name:'',
            phone:'',
            address:'',
            remark:''
        },
        rules:{
            name:{ required: true, message: '请输入联系人姓名', trigger: 'blur' },
            phone:[{ required: true, message: '请输入联系电话号码', trigger: 'blur' },
            { pattern: /^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/, message: '请填写正确的手机/座机' },
            ],
        }
      }
    },
    props: ['contentText'],
    methods: {
        onSubmit(){
          this.$refs['form'].validate((valid) => {
              if (valid) {
                  let params = {
                      platformBannerId:0,
                      linkUserName:this.form.name,
                      linkUserPhone:this.form.phone,
                      userRemark:this.form.address + '; '+this.form.remark,
                  }
                  this.$refs['form'].resetFields();
                  
                  contactUs(params).then(res=>{
                    this.$confirm('提交成功', '提示', {
                      confirmButtonText: '确定',
                      showCancelButton:false,
                      type: 'success',
                      center: true
                    })
                      this.form = {
                          name:'',
                          phone:'',
                          address:'',
                          remark:''
                      }
                  })
              }
          });
        }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .about-us {
    padding-top: 100px;
    background-color: #ffffff;
    .header-bottom {
      width: 100%;
      height: 128px;
      display: flex;
      align-items: center;
      justify-content: center;
  
      .line-style {
        height: 10px;
        display: flex;
        align-items: center;
        flex: 1;
        span {
          display: inline-block;
          background: #181818;
          opacity: 1;
        }
        .dot {
          width: 9px;
          height: 9px;
          border-radius: 50%;
        }
        .lines {
            flex: 1;
          height: 1px;
        }
      }
      .font-size {
        margin: 0 20px;
        .text,
        .letter {
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #181818;
        }
        .text {
          font-size: 40px;
        }
        .letter {
          font-size: 20px;
          font-family: PingFangSC;
        }
      }
    }
    .introduce-main {
      width: 100%;
      padding: 40px 160px;
      background-color: #F5F5F5;
      margin-bottom: 100px;
      .main-title {
        color: #181818;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 20px;
      }
      .main-sub {
        color: #181818;
        font-size: 14px;
      }
      .submit-btn {
        padding: 12px .375rem;
        background-color: #EC892E;
        border: none;
      }
      ::v-deep .el-form-item__label {
        line-height: 20px;
      }
    }
    .scope-of-services {
      background: #f5f5f5;
    //   height: 223px;
        padding-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .server-title {
        text-align: left;
        span {
          display: inline-block;
        }
        .text-title {
          font-size: 24px;
          font-family: PingFangSC;
          font-weight: 500;
          color: #f1bc3f;
        }
        .latter-title {
          margin-left: 10px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: #acacac;
        }
      }
      .server-contetn {
        margin-top: 25px;
        text-align: justify;
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #7b7b7b;
      }
    }
}
  </style>